import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ContactExpertData, DataInfoCard, InfoCard, PermissionsDataFromBE } from 'src/app/models/dashboard/dashboard';
import { AccountService } from 'src/app/services/account/account.service';
import { ModalService } from 'src/app/shared/modal/modal.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  rate: string = '';
  contactExpertData: ContactExpertData | undefined;
  infoCards: InfoCard[] = [
    {
      title: 'DASHBOARD.INFOBOX.CATEGORIAESERVIZI.TITLE',
      icon: 'categorie-servizi',
      disabled: false,
      path: '/categoriesAndServices',
      infos: [
        {
          id: 'elenco',
          active: true,
          title: 'DASHBOARD.INFOBOX.CATEGORIAESERVIZI.TAB1.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.CATEGORIAESERVIZI.TAB1.DESCR'
        },
        {
          id: 'download',
          active: false,
          title: 'DASHBOARD.INFOBOX.CATEGORIAESERVIZI.TAB2.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.CATEGORIAESERVIZI.TAB2.DESCR'
        },
      ]
    },
    {
      title: 'DASHBOARD.INFOBOX.GESTIONEOSPITI.TITLE',
      icon: 'gestione-ospite',
      disabled: false,
      path: '/calendar',
      infos: [
        {
          id: 'prenotazione',
          active: true,
          title: 'DASHBOARD.INFOBOX.GESTIONEOSPITI.TAB1.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.GESTIONEOSPITI.TAB1.DESCR'
        },
        {
          id: 'partners',
          active: false,
          title: 'DASHBOARD.INFOBOX.GESTIONEOSPITI.TAB2.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.GESTIONEOSPITI.TAB2.DESCR'
        },
      ]
    },
    {
      title: 'DASHBOARD.INFOBOX.GESTIONEACCOUNT.TITLE',
      icon: 'gestione-account',
      disabled: false,
      path: '/accountInfo',
      infos: [
        {
          id: 'anagrafica-fornitore',
          active: true,
          title: 'DASHBOARD.INFOBOX.GESTIONEACCOUNT.TAB1.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.GESTIONEACCOUNT.TAB1.DESCR'
        },
        {
          id: 'impostazioni',
          active: false,
          title: 'DASHBOARD.INFOBOX.GESTIONEACCOUNT.TAB2.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.GESTIONEACCOUNT.TAB2.DESCR'
        },
      ]
    },
    {
      title: 'DASHBOARD.INFOBOX.GESTIONETV.TITLE',
      icon: 'tv',
      disabled: false,
      path: '/tvChannels',
      infos: [
        {
          id: 'canali',
          active: true,
          title: 'DASHBOARD.INFOBOX.GESTIONETV.TAB1.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.GESTIONETV.TAB1.DESCR'
        },
        {
          id: 'impostazioni',
          active: false,
          title: 'DASHBOARD.INFOBOX.GESTIONETV.TAB2.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.GESTIONETV.TAB2.DESCR'
        },
        {
          id: 'tv',
          active: false,
          title: 'DASHBOARD.INFOBOX.GESTIONETV.TAB3.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.GESTIONETV.TAB3.DESCR'
        }
      ]
    },
    {
      title: 'DASHBOARD.INFOBOX.DIGITALSIGNAGE.TITLE',
      icon: 'signage',
      disabled: false,
      path: '/signage',
      infos: [
        {
          id: 'monitor',
          active: true,
          title: 'DASHBOARD.INFOBOX.DIGITALSIGNAGE.TAB1.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.DIGITALSIGNAGE.TAB1.DESCR'
        }
      ]
    },
    {
      title: 'DASHBOARD.INFOBOX.INTEGRAZIONE.TITLE',
      icon: 'categorie-servizi',
      disabled: false,
      path: '/webServices',
      infos: [
        {
          id: 'webservice',
          active: true,
          title: 'DASHBOARD.INFOBOX.INTEGRAZIONE.TAB1.SUBTITLE',
          descr: 'DASHBOARD.INFOBOX.INTEGRAZIONE.TAB1.DESCR'
        }
      ]
    }
  ];
  // isOpenAcceptModal: boolean = false;
  isOpenMessage: boolean = false;
  infoCardSelected: DataInfoCard | undefined;


  constructor(
    private accountService: AccountService,
    private translate: TranslateService,
    private router: Router,
    private modal: ModalService
  ) { }

  ngOnInit(): void {


    this.accountService.getEvaluation(this.accountService.vendor).subscribe( (res:PermissionsDataFromBE) => {
      this.rate = res.rate;
      this.contactExpertData = {date: res.date, description: decodeURIComponent( res.description )}
    })
    if( this.accountService.isVendorNotHimself ){
      this.accountService.getPermissions(this.accountService.vendor, localStorage.getItem('HechRomeoEmail'))
        .subscribe(res => {
          this.infoCards[0].disabled = !res.categoriesServices;
          this.infoCards[1].disabled = !res.guestsManagement;
          this.infoCards[3].disabled = !res.tvManagement;
          this.infoCards[4].disabled = !res.digitalSignage;
          this.infoCards[5].disabled = !res.integrations;
        },
        err => console.log('getPermissions' + err.message));
    }
  }

  handlerInfoCard( dataInfoCard: DataInfoCard ){
    if( dataInfoCard.isDiabled ){
      this.translate.get(dataInfoCard.title).subscribe(( titleTranslated: string) =>{
        this.accountService.sendPermisionEmail({
          requester: localStorage.getItem('HechRomeoEmail'),
          section: titleTranslated,
          vendor: this.accountService.vendor
        }).subscribe(res => this.modal.open('DASHBOARD.MODAL.MESSAGEDESCR')  )
      });
    } else {
      this.router.navigate([dataInfoCard.path])
    }
  }

  contactExpertReq(){
     this.accountService.sendPermisionEmail({
          requester: localStorage.getItem('HechRomeoEmail'),
          section: 'Voglio aumentare il livello chiedendo ad un consulente',
          vendor: this.accountService.vendor
        }).subscribe(res => this.modal.open('DASHBOARD.MODAL.MESSAGEDESCR') )
  }

  closeOpenMessage(){
    this.isOpenMessage = false;
  }



}
